import type { TenantConfig } from '@/types/TenantConfig'

export const snowday: TenantConfig = {
  logo: {
    large: 'assets/snowday/static/header.gif',
    small: 'assets/snowday/static/logo.png',
  },
  teaserImageSize: {
    width: 320,
    height: 240,
  },
  themeOptions: {
    primaryColor: '#DD3B6A',
    secondaryColor: '#DD3B6A',
    cartHeaderBackgroundColor: '#1F3A65',
    headerBackground: 'linear-gradient(0deg, rgba(25,162,177,1) 0%, rgba(23,127,149,1) 100%)',
    headerBottomBorder: '0 none',
    footerBackgroundColor: '#1F3A65',
    footerTextColor: 'white',
    logoHeight: '120px',
    headerHeight: '120px',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/snowday/static/completed.gif',
      },
      completedContentOffset: {
        desktop: '-330px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      cartWidget: {
        percentFees: 'Taxes & Fees',
      },
      admitDetailsFields: {
        title: 'Enter details for each person',
        label: '{ttName} {number}ʼs name, age and one gift they want for Christmas',
      },
    },
  },
}
